import { Box, Fade, Skeleton } from "@mui/material";
import ShiftCard from "./shift/ShiftCard";
import EmptyAdminState from "./screens/EmptyAdminState";
import { memo } from "react";
import { useAppContext } from "../../../2_ksbHub/context/appContext";
import EmptyUserState from "./screens/EmptyUserState";
import LockScreen from "./locks/LockScreen";
import useEventLock from "../hooks/useEventLock";
import { useEventManagerContext } from "../context/eventContext";
import { useMemo } from "react";

function EventManagerMain({ viewMode, dialogs, actions }) {
  const { eventManagerLoading } = useAppContext();

  const {
    isAnEventManagerAdmin,
    selectedEvent,
    shifts = [],
    jobs = [],
    angebote = [],
  } = useEventManagerContext();

  const { showLockScreen, unlockTime } = useEventLock();

  const jobsByShift = useMemo(() => {
    if (!jobs.length) return {};
    const map = {};
    jobs.forEach((job) => {
      if (!map[job.shiftId]) map[job.shiftId] = [];
      map[job.shiftId].push(job);
    });
    return map;
  }, [jobs]);

  const angeboteByJobId = useMemo(() => {
    const map = {};
    angebote.forEach((angebot) => {
      if (!map[angebot.jobId]) map[angebot.jobId] = [];
      map[angebot.jobId].push(angebot);
    });
    return map;
  }, [angebote]);

  return (
    <Box sx={{ position: "relative" }}>
      {showLockScreen && <LockScreen unlockTime={unlockTime} />}

      {!showLockScreen && (
        <Fade in={true} timeout={750} key={selectedEvent?.id}>
          <Box>
            {shifts.length === 0 ? (
              isAnEventManagerAdmin ? (
                <EmptyAdminState
                  onCreateEvent={() => dialogs.setCreateEventOpen(true)}
                  onCreateShift={() => dialogs.setCreateShiftOpen(true)}
                />
              ) : (
                <EmptyUserState />
              )
            ) : (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {shifts.map((shift) => (
                  <ShiftCard
                    key={shift.id}
                    shift={shift}
                    jobs={jobsByShift[shift.id] || []}
                    angeboteByJobId={angeboteByJobId}
                    onReserve={actions.handleReserve}
                    viewMode={viewMode}
                    onDeleteJob={actions.handleDeleteJob}
                    onDeleteShift={actions.handleDeleteShift}
                    onEditJob={(job) => {
                      dialogs.setEditingJob(job);
                      dialogs.setCreateJobOpen(true);
                    }}
                    onEditShift={(shift) => {
                      dialogs.setEditingShift(shift);
                      dialogs.setCreateShiftOpen(true);
                    }}
                  />
                ))}
              </Box>
            )}

            {eventManagerLoading && (
              <Box sx={{ position: "absolute", inset: 0 }}>
                <Skeleton width="60%" height={40} />
              </Box>
            )}
          </Box>
        </Fade>
      )}
    </Box>
  );
}

export default memo(EventManagerMain);
